export default __webpack_public_path__ + "static/media/Burger1.92bd84cf.png";